import React, {useEffect, useState} from "react";
import {Redirect, Route, Switch, useLocation} from "react-router-dom";
import {useHistory} from "react-router-dom";
import {useDispatch} from 'react-redux';
import Slide from "@material-ui/core/Slide";
import {
    checkshortcut, checktokenapi, addressimage
} from '../api/api.js';
import URLSearchParams from "url-search-params";
import {userSignInSuccess} from "../actions";
import AwesomeSlider from 'react-awesome-slider';
import AwesomeSliderStyles from '../styles/sliderstyles.scss';
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import DialogContent from "@material-ui/core/DialogContent";
import CloseIcon from '@material-ui/icons/Close';
import NeshanMap from './NeshanMap';
import shareicon from "../assets/images/shareblack.png";
import markerimage from "../assets/images/marker.png";

const useQuery = () => new URLSearchParams(useLocation().search);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const HomeDetails = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const query = useQuery();

    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [allimage, setAllimage] = useState([]);
    const [openmodal, setOpenmodal] = useState(false);
    const [lathome, setLathome] = useState('');
    const [lnghome, setLnghome] = useState('');
    const [map, setMap] = useState(false);
    const [showaddress, setShowaddress] = useState(false);


    useEffect(() => {

        // alert('assd')
        //props.push('/signin');
        let shortcut = query.get('shortcut')

        var body = new FormData();
        body.append('shortcut', shortcut);
        checkshortcut(body)
            .then((response) => {
                if (response.data.errorCode === 0) {
                    console.log(response.data);
                    setName('اقامتگاه ' + response.data.Details.Name);
                    setAddress(response.data.Details.Address);
                    setAllimage(response.data.Details.images);
                    setLathome(response.data.Details.Lat);
                    setLnghome(response.data.Details.Lng);
                    setMap(true);


                    if(response.data.Details.ShortToken === shortcut){
                        setShowaddress(false);
                    }else {
                        setShowaddress(true);
                    }



                } else {

                }

            })
            .catch((error) => {
                debugger;

            })


    }, []);

    function handleClick() {
        var delayInMilliseconds = 2000; //1 second

        setTimeout(function () {
            //your code to be executed after 1 second

            //history.push("/");
            //   dispatch(userSignOut());

        }, delayInMilliseconds);


    }

    const closecarousel = () => {
        // setOpen(true);
        setOpenmodal(false);
    }

    function myNavFunc() {
        // If it's an iPhone..
        if ((navigator.platform.indexOf("iPhone") != -1)
            || (navigator.platform.indexOf("iPod") != -1)
            || (navigator.platform.indexOf("iPad") != -1))
            // window.open("maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=" + lathome + "," + lnghome);
            window.open("maps://?q=" + lathome + "," + lnghome);
        else
            window.open("https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=" + lathome + "," + lnghome);
    }


    return (


        <div style={{backgroundColor: '#ffffff', overflow: 'scroll', width: '100%', height: '100%', padding: 20}}>

            <h2 className="title_price">{name}</h2>


            <div style={{display: 'flex', flexDirection: 'column'}}>

                {allimage.map((item, index) => (
                    // <div
                    //
                    //     data-src={addressimage(item.preview)} onClick={() => setOpenmodal(true)}/>


                    <img
                        src={addressimage(item.preview)}
                        style={{
                            width: '100%',
                            marginTop: 10

                        }}
                    />


                ))}


            </div>


            {showaddress ?

                <div>

                    <h2 style={{marginTop: 10, marginBottom: 10}} className="title_price">آدرس</h2>


                    <div style={{marginTop: 5, fontFamily: 'iransans', fontSize: 15, color: '#000'}}>
                        {address}
                    </div>


                    {map ?

                        <div style={{width: '100%', height: 300, marginTop: 10, position: 'relative'}}>

                            {/*<img*/}
                            {/*    src={markerimage}*/}
                            {/*    style={{*/}
                            {/*        width: 40, height: 40, top: '50%',*/}
                            {/*        left: '50%',*/}
                            {/*        transform: 'translate(-50%, -50%)', position: 'absolute', zIndex: 999*/}
                            {/*    }}*/}
                            {/*/>*/}

                            {/*<MapContainer style={{width: '100%', height: '100%', marginTop: 15}}*/}
                            {/*              center={[lathome, lnghome]}*/}
                            {/*              zoom={13} scrollWheelZoom={false}>*/}
                            {/*    /!*<MapConsumer>*!/*/}
                            {/*    /!*    {(map) => {*!/*/}
                            {/*    /!*    console.log('map center:', map.getCenter());*!/*/}
                            {/*    /!*    return null;*!/*/}
                            {/*    /!*}}*!/*/}
                            {/*    /!*</MapConsumer>*!/*/}
                            {/*    /!*<MyComponent />*!/*/}
                            {/*    <TileLayer*/}
                            {/*        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> App Mizbanan'*/}
                            {/*        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"*/}
                            {/*    />*/}
                            {/*    /!*<Marker position={[35.7067354, 51.3729428]}>*!/*/}
                            {/*    /!*    <Popup>*!/*/}
                            {/*    /!*        A pretty CSS3 popup. <br/> Easily customizable.*!/*/}
                            {/*    /!*    </Popup>*!/*/}
                            {/*    /!*</Marker>*!/*/}
                            {/*    <MyComponentInfo/>*/}
                            {/*</MapContainer>*/}
                            <NeshanMap style={{width: '100%', height: '100%'}}
                                       options={{
                                           key: "web.1JLzpqjPI5SuVdgDnJ48P8C9MI2rnRN6dXnF9I4g",
                                           maptype: "dreamy",
                                           poi: true,
                                           traffic: false,
                                           center: [lathome, lnghome],
                                           zoom: 13,
                                       }}

                                       onInit={(L, myMap) => {
                                           let marker = L.marker([lathome, lnghome])
                                               .addTo(myMap)
                                               .bindPopup(address);

                                           // myMap.on('click', function (e) {
                                           //     marker.setLatLng(e.latlng)
                                           // });

                                       }}
                            />

                        </div>


                        :

                        null


                    }


                    <div style={{textAlign: 'center', flex: 1, marginTop: 10}}>

                        <div onClick={myNavFunc} style={{
                            cursor: 'pointer',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: 60,
                            height: 60,
                            margin: '0 auto',
                            borderRadius: '50%',
                            borderWidth: '0.1em',
                            border: 'solid',
                            borderColor: '#dadada'
                        }}>
                            <div style={{margin: '0 auto'}}>
                                <img src={shareicon} style={{width: 30, height: 30}}></img>
                            </div>
                        </div>

                        <div style={{
                            marginTop: 10,
                            fontFamily: 'iransans',
                            fontWeight: 'bold',
                            fontSize: 12,
                            color: '#000'
                        }}>
                            مسیریابی آدرس
                        </div>

                    </div>


                </div>


                :


                null


            }


            {/*<Redirect*/}
            {/*to={{*/}
            {/*pathname: '/signin',*/}

            {/*}}*/}
            {/*/>*/}

            {/*<div>armin</div>*/}


            <Dialog fullScreen TransitionComponent={Transition} disableEnforceFocus
                    open={openmodal}>
                {/*<DialogTitle id="customized-dialog-title" onClose={handleClose}>*/}
                {/*ویرایش تقویم*/}
                {/*</DialogTitle>*/}
                {/*<div style={{margin: 10, fontFamily: 'iransans', fontSize: 15}}>*/}
                {/*ویرایش تقویم*/}
                {/*</div>*/}

                <div style={{
                    display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', width: '100%'
                }}>


                    <IconButton onClick={closecarousel} aria-label="Close">
                        <CloseIcon/>
                    </IconButton>
                </div>


                <DialogContent dividers>
                    {/*<Typography gutterBottom>*/}
                    {/*Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis*/}
                    {/*in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.*/}
                    {/*</Typography>*/}
                    {/*<Typography gutterBottom>*/}
                    {/*Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis*/}
                    {/*lacus vel augue laoreet rutrum faucibus dolor auctor.*/}
                    {/*</Typography>*/}
                    {/*<Typography gutterBottom>*/}
                    {/*Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel*/}
                    {/*scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus*/}
                    {/*auctor fringilla.*/}
                    {/*</Typography>*/}


                    {/*<div className="d-flex flex-column" style={{fontFamily:'iransans',fontSize:10}}>*/}

                    {/*<div>نوع ویرایش را انتخاب کنید:</div>*/}

                    {/*<div className="d-flex align-items-center" style={{marginTop:10}}>*/}

                    {/*<div className={classes.border} style={{width:'100%',height:30 ,marginLeft:5, flex: 1,display:'flex',flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>*/}

                    {/*<div style={{fontSize:8}}>تغییر قیمت ها</div>*/}


                    {/*</div>*/}

                    {/*<div className={classes.border} style={{width:'100%',height:30 ,marginRight:5, flex: 1,display:'flex',flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>*/}

                    {/*<div style={{fontSize:8}}>ثبت رزروهای شخصی</div>*/}

                    {/*</div>*/}


                    {/*</div>*/}

                    {/*</div>*/}


                    {/*<div style={{*/}
                    {/*    height: '100%',*/}
                    {/*    width: '100%',*/}
                    {/*    display: 'flex',*/}
                    {/*    alignItems: 'center',*/}
                    {/*    justifyContent: 'center'*/}
                    {/*}}>*/}
                    {/*    <BearCarousel*/}
                    {/*        data={bearSlideItemData}*/}
                    {/*        staticHeight="400px"*/}
                    {/*        isEnableNavButton*/}
                    {/*        isEnablePagination*/}


                    {/*    />*/}
                    {/*</div>*/}

                    <AwesomeSlider cssModule={AwesomeSliderStyles} infinite={false}>

                        {/*<LazyLoadImage className={classes.image}*/}
                        {/*               onClick={() => props.opendialog(props.index, props.data.ProductId, props.data.ListOrderId)}*/}
                        {/*               placeholder={<div style={{*/}
                        {/*                   width: '100%', display: 'flex'*/}
                        {/*                   , justifyContent: 'center', marginTop: 30*/}
                        {/*               }}>*/}
                        {/*                   <PulseLoader color="#673ab7" size="16px" margin="4px"/>*/}
                        {/*               </div>}*/}
                        {/*               alt={props.key}*/}
                        {/*               // src={addressimage(props.data.Avatar)} // use normal <img> attributes as props*/}
                        {/*               src="https://mcdn.mihmansho.com/products/1024/home_m_mp_4229_33350_14001217135833_1024.jpg" // use normal <img> attributes as props*/}
                        {/*/>*/}
                        {/*<div*/}
                        {/*    data-src="https://mcdn.mihmansho.com/products/1024/home_m_mp_4229_33350_14001217135833_1024.jpg"/>*/}
                        {/*<div*/}
                        {/*    data-src="https://mcdn.mihmansho.com/products/1024/home_m_mp_4229_33350_14001217135833_1024.jpg"/>*/}


                        {allimage.map((item, index) => (
                            <div

                                data-src={addressimage(item.preview)}/>
                        ))}

                    </AwesomeSlider>


                </DialogContent>
                {/*<DialogActions>*/}
                {/*<Button autoFocus onClick={handleClose} color="primary">*/}
                {/*Save changes*/}
                {/*</Button>*/}
                {/*</DialogActions>*/}
            </Dialog>


        </div>


    );

};


export default HomeDetails;


